export const isValidEmail = (email: string) => {
  let emailRegex = /\S+@\S+\.\S+/

  return emailRegex.test(email)
}
